import { ReactElement } from 'react';

import { Gender } from '@dreryk/egabinet-patient-frontend-api';

import { StandardSpinner } from '@dreryk/react-components';

import { usePatientQuery } from './common.hooks';

type ResourceByPatientGenderGuardProps = {
   readonly patientId: number;
   readonly children: ReactElement;
   readonly gender: Gender;
};

export const ResourceByPatientGenderGuard = (props: ResourceByPatientGenderGuardProps): JSX.Element | null => {
   const { data: patient, loading: patientLoading } = usePatientQuery(props.patientId);

   if (patientLoading) {
      return <StandardSpinner />;
   }

   if (!patient || patient.gender !== props.gender) {
      return null;
   }

   return props.children;
};
